import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import SwalServices from '../../../services/swalServices/SwalServices';
import { SalesInvoicePopup } from './SalesInvoiceTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';

export default class SalesInvoice extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            urlId: 0,
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColdefs: [],
            challanFromList: [
                { value: 1, label: 'TAX INVOICE' },
                { value: 2, label: 'REJECTION' },
                { value: 3, label: 'SCRAP' }
            ],
            invTypeList: [
                { value: 1, label: 'INTRASTATE' }
            ],
            challanList: [],
            partyAccountList: [],
            accountHeadList: [],
            taxStructureList: [],
            pTermsList: [
                { value: 1, label: 'NET 15' },
                { value: 2, label: 'NET 30' },
                { value: 3, label: 'NET 45' },
                { value: 4, label: 'NET 60' },
                { value: 5, label: 'NET 90' }
            ],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            salesObject: {
                idSalesInvoice: 0,
                idChallanInvoice: 0,
                updateStatus: 0,
                invoiceNo: '',
                invoiceDate: '',
                // idChallanInvoice: '',
                challanFrom: '',
                challanType: '',
                intWONumber: '',
                idWOOrderRecv: 0,
                idVendor: '',
                idDelivery: '',
                idAccountHead: '',
                challanCategory: 'PARTY WORK ORDER',
                orderNo: '',
                orderDate: '',
                customerAddress: '',
                deliveryAddress: '',
                destination: "",
                challanNo: "",
                challanDate: "",
                vehicleNo: "",
                transporter: "",
                idTerms: "",
                dueDate: "",
                tcsCharges: "",
                tcsAmount: "",

                totalAmt: 0,
                totalQty: 0,
                extraCharges: 0,
                discount: 0,
                taxAmt: 0,
                taxableAmt: 0,
                adjustableAmt: 0,
                totalTaxAmt: 0,
                finalAmt: 0,
                remarks: "",
                totalArticle: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                invoiceDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice date"
                        ),
                    },
                ],
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
                // idAccountHead: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.SelectRequired.replace(
                //             "{0}",
                //             "account head"
                //         ),
                //     },
                // ],
            },
            validationRules: {
                product: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxStructure: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Sales Invoice",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            pinned: ["sR.No", "invoiceFrom", "challanNo", "rejectionNo", "workOrder"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idSalesInvoice",].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Sales Invoice",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Sales Invoice");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.salesObject;
        details.idSalesInvoice = id;
        this.setState({ salesObject: details }, () => {
            this.usp_Transaction_SalesInvoiceSelectbyId(this.state.salesObject.idSalesInvoice);
        });
    };

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "invoiceNo": window.innerWidth * 0.05,
            "invoiceDate": window.innerWidth * 0.08,
            "customer": window.innerWidth * 0.2,
            "delivery": window.innerWidth * 0.2,
            "dueDate": window.innerWidth * 0.08,
            "totalQty": window.innerWidth * 0.06,
            "totalAmt": window.innerWidth * 0.08,
            "extraCharges": window.innerWidth * 0.06,
            "discount": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.04,
            "invoiceFrom": window.innerWidth * 0.08,
            "challanNo": window.innerWidth * 0.06,
            "rejectionNo": window.innerWidth * 0.06,
            "workOrder": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.2,
            "hsnCode": window.innerWidth * 0.06,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        this.getMasterAccountHeadSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getMasterAccountHeadSelect();
                }
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {

                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                }));
                this.setState({ accountHeadList: data }, () => {
                    this.getChallanList();
                });
            } else {
                this.getChallanList();
            }
        });
    }

    getChallanList = (status, id) => {
        let request = {
            idSalesInvoice: this.state.salesObject.idSalesInvoice,
            idCompany: this.state.idCompany,
            updateStatus: status === 'Updated' ? 1 : this.state.salesObject.updateStatus,
        };
        this.transactionStockServices.usp_Transaction_ChallanInvoiceSelectForInvoice(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idChallanInvoice,
                    label: x.challanNo + " - " + x.customer,
                }));
                this.setState({ challanList: data }, () => {
                    this.getTaxStructureList();
                    if (status === 'Updated') {
                        this.usp_Transaction_SalesInvoiceSelectbyId(id);
                    }
                })
            } else {
                this.getTaxStructureList();
            }
        });
    }

    getTaxStructureList = () => {
        let request = {
            formname: "Tax Structure Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[1];
                data = data.map((x) => ({
                    idTaxStructure: x.idTaxStructure,
                    label: x.taxGroupName,
                    value: x.idTaxStructure,
                    sgst: x.sgst ? x.sgst : 0,
                    cgst: x.cgst ? x.cgst : 0,
                    igst: x.igst ? x.igst : 0
                }));
                this.setState({ taxStructureList: data })
            }
        });
    }

    handleCellClick = (event) => {
        let data = this.state.salesObject;
        data.idSalesInvoice = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ salesObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Sales Invoice");
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.transactionStockServices.getInvoiceCountForSalesInvoice(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let salesObject = this.state.salesObject
                salesObject.invoiceNo = formatted
                this.setState({ salesObject: salesObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getChallanList('Updated', event.data.idSalesInvoice);
        // this.usp_Transaction_SalesInvoiceSelectbyId(event.data.idSalesInvoice);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.salesObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
        this.setState({ isModalOpen: false, });
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.salesObject;
        details[name] = value;
        this.setState({ salesObject: details }, () => {
            this.calculatePricing();
        });
    }

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    resetDetailsFields = () => {
        let details = this.state.salesObject;
        details.idSalesInvoice = 0;
        details.invoiceDate = '';
        details.idChallanInvoice = '';
        details.updateStatus = 0; // Default to 'New'
        details.challanFrom = 1; // Default to 'TAX INVOICE'
        details.challanType = 1; // Default to 'INTRASTATE'
        details.intWONumber = '';
        details.idWOOrderRecv = 0;
        details.idVendor = '';
        details.idDelivery = '';
        details.idAccountHead = '';
        details.challanCategory = 'PARTY WORK ORDER';
        details.orderNo = '';
        details.orderDate = '';
        details.customerAddress = '';
        details.deliveryAddress = '';
        details.destination = "";
        details.vehicleNo = "";
        details.transporter = "";
        details.idTerms = 1; // Default to 'NET 15'
        details.dueDate = '';
        details.tcsCharges = 0;
        details.tcsAmount = 0;
        details.totalAmt = 0;
        details.totalQty = 0;
        details.extraCharges = 0;
        details.discount = 0;
        details.taxAmt = 0;
        details.totalTaxAmt = 0;
        details.finalAmt = 0;
        details.remarks = "";
        details.totalArticle = 0;
        details.taxableAmt = 0
        details.adjustableAmt = 0

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            salesObject: details,
            itemRowData: []
        }, () => {
            this.getChallanList()
        });
    }

    setFilterParameters = (event, name) => {
        let details = this.state.salesObject;
        if (name === 'idChallanInvoice') {
            details.idChallanInvoice = event.value;
            this.getTransactionDeliveryChallanByID(event.value);
        } else {
            details[name] = event.value;
        }
        if (name === 'idDelivery') {
            details.deliveryAddress = event.partyAddress
        }
        if (name === 'idVendor') {
            details.customerAddress = event.partyAddress
        }
        this.setState({ salesObject: details });
    }

    getTransactionDeliveryChallanByID = (id) => {
        this.transactionStockServices.getTransactionDeliveryChallanByID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.salesObject;
                    data.idChallanInvoice = res.idChallanInvoice;
                    data.challanNo = res.challanNo;
                    data.challanDate = res.challanDate ? moment(res.challanDate).format('YYYY-MM-DD') : "";
                    data.challanFrom = res.challanFrom ? this.state.challanFromList.find(x => x.label === res.challanFrom)?.value || 1 : 1;
                    data.challanType = res.challanType ? this.state.invTypeList.find(x => x.label === res.challanType)?.value || 1 : 1;
                    data.idVendor = res.idCustomer;
                    data.idDelivery = res.idDelivery;
                    data.customerAddress = res.idCustomer ? this.state.partyAccountList.find(x => x.value === res.idCustomer)?.partyAddress || "" : "";
                    data.deliveryAddress = res.idDelivery ? this.state.partyAccountList.find(x => x.value === res.idDelivery)?.partyAddress || "" : "";
                    data.orderNo = res.orderNo;
                    data.orderDate = res.orderDate ? moment(res.orderDate).format('YYYY-MM-DD') : "";
                    data.vehicleNo = res.vehicleNo;
                    data.transporter = res.transporter;
                    data.idAccountHead = res.idGeneralProduct;
                    data.idTerms = res.paymentTerms ? this.state.pTermsList.find(x => x.label === res.paymentTerms)?.value || 1 : 1;
                    data.e_Date = res.e_Date ? res.e_Date : null;
                    data.idCustomer = res.idCustomer;
                    data.idWOOrderRecv = res.idWOOrderRecv ? res.idWOOrderRecv : 0;
                    data.intWONumber = res.intWONumber ? res.intWONumber : '';
                    data.idChallanInvoice = res.idChallanInvoice ? res.idChallanInvoice : 0;

                    this.setState({
                        deliveryObject: data,
                        isModalOpen: true
                    });
                    this.transactionStockServices.getTransactionDeliveryChallanItemsByID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;

                            if (value.length > 0) {
                                this.calculateItemListing(value)
                            }

                        }
                    });

                }
            }
        });
    }

    calculateItemListing = (value) => {
        const groupedMap = new Map();

        value.forEach((x) => {
            const key = `${x.idItem}_${x.drawingNo}_${x.itemName}`;

            x.quantity = Number(x.quantity) || 0;
            x.pendingQty = Number(x.woQuantity) || 0;
            x.itemType = x.itemItemType || '';
            x.itemRate = Number(x.itemRate) || 0;
            x.extraCharges = Number(x.extraCharges) || 0;
            x.discount = Number(x.discount) || 0;

            if (!groupedMap.has(key)) {
                groupedMap.set(key, { ...x });
            } else {
                let existing = groupedMap.get(key);
                existing.quantity += x.quantity;
                existing.pendingQty += x.pendingQty;
                existing.extraCharges += x.extraCharges;
            }
        });

        const mergedArray = Array.from(groupedMap.values());

        mergedArray.forEach((x) => {
            let baseAmount = x.itemRate * x.quantity;
            let discountAmount = (x.discount * baseAmount) / 100;
            let amountAfterDiscount = Math.max(baseAmount - discountAmount, 0);

            let taxableAmount = amountAfterDiscount + x.extraCharges;
            let sgst = 0, cgst = 0, igst = 0;
            if (x.idTaxGroup > 0) {
                let tax = this.state.taxStructureList.find(y => y.idTaxStructure === x.idTaxGroup);
                if (tax) {
                    sgst = tax.sgst || 0;
                    cgst = tax.cgst || 0;
                    igst = tax.igst || 0;
                }
            }

            let sgstAmt = this.state.salesObject.challanType === 1 ? (taxableAmount * sgst) / 100 : 0;
            let cgstAmt = this.state.salesObject.challanType === 1 ? (taxableAmount * cgst) / 100 : 0;
            let igstAmt = this.state.salesObject.challanType === 1 ? 0 : (taxableAmount * igst) / 100;

            let totalTax = sgstAmt + cgstAmt + igstAmt;

            let netTotal = taxableAmount + totalTax;

            x.baseAmount = baseAmount;
            x.amount = baseAmount;
            x.discountAmt = discountAmount;
            x.amountAfterDiscount = amountAfterDiscount;
            x.taxableAmt = taxableAmount;
            x.sgst = sgst;
            x.cgst = cgst;
            x.igst = igst;
            x.sgstAmt = sgstAmt;
            x.cgstAmt = cgstAmt;
            x.igstAmt = igstAmt;
            x.taxAmt = totalTax;
            x.netTotal = netTotal;
        });

        this.setState({ itemRowData: mergedArray }, () => {
            this.calculatePricing();
        });
    };


    calculatePricing = () => {
        let itemRowData = this.state.itemRowData;

        let totalQty = 0, totalBaseAmount = 0, totalExtraCharges = 0, totalDiscountAmount = 0;
        let sgstAmt = 0, cgstAmt = 0, igstAmt = 0, totalWithTax = 0, taxableAmt = 0
        // adjustableAmt = 0;

        itemRowData.forEach(item => {
            const qty = Number(item.quantity) || 0;
            const amount = Number(item.amount) || 0; // base amount before tax
            const extraCharge = Number(item.extraCharges) || 0;
            const discountPercent = Number(item.discount) || 0;
            const discountAmount = (amount * discountPercent) / 100;
            const taxableAmount = Number(item.taxableAmt) || 0;

            const sgst = Number(item.sgstAmt) || 0;
            const cgst = Number(item.cgstAmt) || 0;
            const igst = Number(item.igstAmt) || 0;
            const netTotal = Number(item.netTotal) || 0;

            totalQty += qty;
            totalBaseAmount += amount;
            totalExtraCharges += extraCharge;
            totalDiscountAmount += discountAmount;
            taxableAmt += taxableAmount;
            sgstAmt += sgst;
            cgstAmt += cgst;
            igstAmt += igst;
            totalWithTax += netTotal;
        });

        const totalTaxAmt = sgstAmt + cgstAmt + igstAmt;

        let details = { ...this.state.salesObject };
        details.totalQty = totalQty.toFixed(2);
        details.totalAmt = totalBaseAmount.toFixed(2);
        details.extraCharges = totalExtraCharges.toFixed(2);
        details.discount = totalDiscountAmount.toFixed(2); // now actual discount amount
        details.taxAmt = totalTaxAmt.toFixed(2);
        details.totalTaxAmt = totalWithTax.toFixed(2);
        details.taxableAmt = taxableAmt.toFixed(2)

        // Final Amount = TotalWithTax + ExtraCharges - Discount
        let finalAmount = totalWithTax;

        // Handle TCS if applicable
        if (details.tcsCharges && details.tcsCharges > 0) {
            const tcsRate = Number(details.tcsCharges) / 100;
            const tcsBase = totalWithTax;
            const tcsAmount = tcsBase * tcsRate;

            details.tcsAmount = tcsAmount.toFixed(2);
            finalAmount += tcsAmount;
        }

        if (details.adjustableAmt > 0) {
            const adjustAmt = Number(details.adjustableAmt)
            finalAmount += adjustAmt
        }

        details.finalAmt = Math.round(finalAmount).toFixed(2);

        this.setState({ salesObject: details });
    };



    submit = () => {
        if (this.isSubmitting) { return; }
        const isValidAllFields = this.isValidAllFieldsForWork();
        if (isValidAllFields) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Error("Please add required details.");
            } else {
                let details = this.state.salesObject;
                let details2 = this.state.itemRowData;
                let salesInvoiceItemList = [];
                details2.map((x) => {
                    let request = {
                        drawingNo: x.drawingNo,
                        itemType: x.itemType,
                        itemRemarks: x.remarks ? x.remarks : '',
                        displaySerialNo: x.displaySerialNo ? x.displaySerialNo : '',
                        idItem: x.idItem ? x.idItem : '',
                        woQty: 0,
                        idTaxGroup: x.idTaxGroup ? x.idTaxGroup : '',
                        quantity: x.quantity ? Number(x.quantity).toFixed(2) : 0,
                        rate: x.itemRate ? Number(x.itemRate).toFixed(2) : 0,
                        amount: x.amount ? Number(x.amount).toFixed(2) : 0,
                        discount: x.discount ? Number(x.discount).toFixed(2) : 0,
                        extraCharges: x.extraCharges ? Number(x.extraCharges).toFixed(2) : 0,
                        taxableAmt: x.taxAmt ? Number(x.taxAmt).toFixed(2) : 0,
                        sgst: x.sgst ? Number(x.sgst).toFixed(2) : 0,
                        sgstAmt: x.sgstAmt ? Number(x.sgstAmt).toFixed(2) : 0,
                        cgst: x.cgst ? Number(x.cgst).toFixed(2) : 0,
                        cgstAmt: x.cgstAmt ? Number(x.cgstAmt).toFixed(2) : 0,
                        igst: x.igst ? Number(x.igst).toFixed(2) : 0,
                        igstAmt: x.igstAmt ? Number(x.igstAmt).toFixed(2) : 0,
                        netTotal: x.netTotal ? Number(x.netTotal).toFixed(2) : 0,
                        IdChallanInvoiceItems: x.idChallanInvoiceItems ? x.idChallanInvoiceItems : 0,
                        idWo: details.idWOOrderRecv ? details.idWOOrderRecv : 0,
                        idIntWo: details.intWONumber ? details.intWONumber : '',
                        isTaxOrRejection: details.challanFrom === 'REJECTION' ? true : false,
                        idWorkOrderRecv: 0,
                        idWorkOrderRecvItems: 0,
                        idMaterialRejection: 0,
                        idMaterialRejectionItems: 0,
                    }
                    salesInvoiceItemList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idSalesInvoice: details.idSalesInvoice > 0 ? details.idSalesInvoice : 0,
                        idChallanInvoice: details.idChallanInvoice > 0 ? details.idChallanInvoice : 0,
                        invoiceNo: details.invoiceNo,
                        updateStatus: details.updateStatus,
                        invoiceDate: (details.invoiceDate && details.invoiceDate !== 'Invalid date') ? details.invoiceDate : null,
                        invoiceFrom: details.challanFrom > 0 ? this.state.challanFromList.find(x => x.value === details.challanFrom).label : '',
                        idAccountHead: details.idAccountHead,
                        invoiceCategory: details.challanCategory,
                        intWONumber: details.intWONumber ? details.intWONumber : '',
                        idWOOrderRecv: details.idWOOrderRecv ? details.idWOOrderRecv : 0,
                        invoiceType: details.challanType > 0 ? this.state.invTypeList.find(x => x.value === details.challanType).label : '',
                        idCustomer: details.idVendor,
                        idDelivery: details.idDelivery,
                        destination: details.destination ? details.destination : '',
                        paymentTerms: details.idTerms ? this.state.pTermsList.find(x => x.value === details.idTerms).label : '',
                        dueDate: (details.dueDate && details.dueDate !== 'Invalid date') ? details.dueDate : null,
                        orderNo: details.orderNo,
                        orderDate: (details.orderDate && details.orderDate !== 'Invalid date') ? details.orderDate : null,
                        challanNo: details.challanNo,
                        challanDate: (details.challanDate && details.challanDate !== 'Invalid date') ? details.challanDate : null,
                        vehicleNo: details.vehicleNo,
                        transporter: details.transporter,
                        totalQty: details.totalQty,
                        taxAmt: Number(details.taxAmt) ? Number(details.taxAmt).toFixed(2) : 0,
                        totalTaxAmt: details.totalTaxAmt ? Number(details.totalTaxAmt).toFixed(2) : 0,
                        totalWithTax: details.totalTaxAmt ? Number(details.totalTaxAmt).toFixed(2) : 0,
                        totalAmt: Number(details.totalAmt).toFixed(2),
                        extraCharges: Number(details.extraCharges).toFixed(2),
                        discount: Number(details.discount).toFixed(2),
                        tcsCharges: details.tcsCharges ? Number(details.tcsCharges).toFixed(2) : 0,
                        tcsAmount: details.tcsAmount ? Number(details.tcsAmount).toFixed(2) : 0,
                        finalAmt: Number(details.finalAmt).toFixed(2),
                        remarks: details.remarks ? details.remarks : '',
                        totalArticle: details.totalArticle,
                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updateStatus > 0 ? new Date() : null,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        taxableAmt: details.taxableAmt,
                        adjustableAmt: details.adjustableAmt,
                        salesInvoiceItemList: salesInvoiceItemList,
                    }
                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.transactionStockServices.submitTransaction_SalesInvoiceInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode === 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.salesObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    if (this.state.urlId) {
                                        this.setState({ route: '/ledger-report' });
                                    } else {
                                        this.resetDetailsFields();
                                        this.setState(
                                            { isModalOpen: false },
                                            () => {
                                                this.procSelectAllRecordsSP();
                                            }
                                        );
                                    }
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        }).finally(() => { this.isSubmitting = false; this.setState({ isSaving: false }); });
                }
            }
        }
    }

    usp_Transaction_SalesInvoiceSelectbyId = (id) => {
        this.transactionStockServices.usp_Transaction_SalesInvoiceSelectbyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.salesObject;
                    data.idSalesInvoice = res.idSalesInvoice;
                    data.idChallanInvoice = res.idChallanInvoice;
                    data.invoiceNo = res.invoiceNo;
                    data.updateStatus = 1;
                    data.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : "";
                    data.challanFrom = res.invoiceFrom ? this.state.challanFromList.find(x => x.label === res.invoiceFrom)?.value || 1 : 1;
                    data.challanType = res.invoiceType ? this.state.invTypeList.find(x => x.label === res.invoiceType)?.value || 1 : 1;
                    data.challanCategory = res.invoiceCategory;
                    data.intWONumber = res.intWONumber ? res.intWONumber : '';
                    data.idWOOrderRecv = res.idWOOrderRecv ? res.idWOOrderRecv : 0;
                    data.idVendor = res.idCustomer;
                    data.idDelivery = res.idDelivery;
                    data.customerAddress = res.idCustomer ? this.state.partyAccountList.find(x => x.value === res.idCustomer)?.partyAddress || "" : "";
                    data.deliveryAddress = res.idDelivery ? this.state.partyAccountList.find(x => x.value === res.idDelivery)?.partyAddress || "" : "";
                    data.destination = res.destination ? res.destination : "";
                    data.idTerms = res.paymentTerms ? this.state.pTermsList.find(x => x.label === res.paymentTerms)?.value || 1 : 1;
                    data.dueDate = res.dueDate ? moment(res.dueDate).format('YYYY-MM-DD') : "";
                    data.orderNo = res.orderNo;
                    data.orderDate = res.orderDate ? moment(res.orderDate).format('YYYY-MM-DD') : "";
                    data.challanNo = res.challanNo;
                    data.challanDate = res.challanDate ? moment(res.challanDate).format('YYYY-MM-DD') : "";
                    data.vehicleNo = res.vehicleNo;
                    data.transporter = res.transporter;
                    data.idAccountHead = res.idAccountHead;
                    data.e_Date = res.e_Date ? res.e_Date : null;
                    data.totalQty = res.totalQty ? Number(res.totalQty).toFixed(2) : 0;
                    data.totalTaxAmt = res.totalwithTax ? Number(res.totalwithTax).toFixed(2) : 0;
                    data.extraCharges = res.extraCharges ? Number(res.extraCharges).toFixed(2) : 0;
                    data.discount = res.discount ? Number(res.discount).toFixed(2) : 0;
                    data.taxAmt = res.taxAmt ? Number(res.taxAmt).toFixed(2) : 0;
                    data.totalAmt = res.totalAmt ? Number(res.totalAmt).toFixed(2) : 0;
                    data.tcsCharges = res.tcsCharges ? Number(res.tcsCharges).toFixed(2) : 0;
                    data.tcsAmount = res.tcsAmount ? Number(res.tcsAmount).toFixed(2) : 0;
                    data.finalAmt = res.finalAmt ? Number(res.finalAmt).toFixed(2) : 0;
                    data.totalArticle = res.totalArticle ? res.totalArticle : 0;
                    data.taxableAmt = res.taxableAmt ? Number(res.taxableAmt).toFixed(2) : 0;
                    data.adjustableAmt = res.adjustableAmt ? Number(res.adjustableAmt).toFixed(2) : 0
                    data.idAccountHead = res.idGeneralProduct ? res.idGeneralProduct : 0;
                    this.setState({
                        salesObject: data,
                        isModalOpen: true
                    });
                    this.transactionStockServices.usp_Transaction_SalesInvoiceItemsSelectbyId(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            value.map((x) => {
                                x.amount = x.amount ? Number(x.amount).toFixed(2) : 0;
                                x.itemRate = x.rate ? Number(x.rate) : 0;
                                x.discount = x.discount ? Number(x.discount).toFixed(2) : 0
                                x.extraCharges = x.extraCharges ? Number(x.extraCharges).toFixed(2) : 0;
                                x.taxAmt = x.taxableAmt ? Number(x.taxableAmt).toFixed(2) : 0;
                                x.sgstAmt = x.sgstAmt ? Number(x.sgstAmt).toFixed(2) : 0;
                                x.cgstAmt = x.cgstAmt ? Number(x.cgstAmt).toFixed(2) : 0;
                                x.igstAmt = x.igstAmt ? Number(x.igstAmt).toFixed(2) : 0;
                                x.netTotal = x.netTotal ? Number(x.netTotal).toFixed(2) : 0;
                            });
                            if (value.length > 0) {
                                this.setState({ itemRowData: value }, () => {
                                    this.calculateItemListing(this.state.itemRowData);
                                });
                            }
                        }
                    });

                }
            }
        });
    }

    onCellValueChanged = (params) => {
        const updatedData = [];
        params.api.forEachNode((node) => {
            updatedData.push(node.data);
        });
        this.calculateItemListing(updatedData);
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <SalesInvoicePopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            salesObject={this.state.salesObject}
                            itemObject={this.state.itemObject}
                            handleChangeForWork={this.handleChangeForWork.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColdefs={this.state.itemColdefs}

                            challanFromList={this.state.challanFromList}
                            invTypeList={this.state.invTypeList}
                            accountHeadList={this.state.accountHeadList}
                            partyAccountList={this.state.partyAccountList}
                            pTermsList={this.state.pTermsList}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            challanList={this.state.challanList}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            calcualteItem={this.calculateItemListing.bind(this)}
                            onCellValueChanged={this.onCellValueChanged.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 450px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Sales invoice</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onCellClicked={this.handleCellClick}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
